import { gql } from "@apollo/client";

import {
  DOCUMENT_FRAGMENT,
  DOCUMENT_LIST_FRAGMENT,
  DOCUMENT_TYPE_INFO_FRAGMENT,
} from "@graphql/fragments/documents";

export const DOCUMENT_TYPES = gql`
  ${DOCUMENT_TYPE_INFO_FRAGMENT}

  query documentTypes {
    documentTypes {
      ...DocumentTypeInfoFragment
    }
  }
`;

export const DOCUMENTS = gql`
  ${DOCUMENT_LIST_FRAGMENT}

  query documents($input: DocumentsInput!) {
    documents(input: $input) {
      ...DocumentListFragment
    }
  }
`;

export const DOCUMENT = gql`
  ${DOCUMENT_FRAGMENT}

  query document($input: DocumentInput!) {
    document(input: $input) {
      ...DocumentFragment
    }
  }
`;
